import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { loadingTypes } from "../../../../Utils/constant";
import {
  deleteScheduledOneTimePayment,
  fetchBorrowerOneTimeScheduledPayments,
} from "../../../../store/reducers/dashboardSlice/api";
import { useAbortController } from "../../../../hooks/useAbortController";
import { DeleteButton, SpinnerBlock } from "../../../../Utils/CustomComponent";
import { Trash3Fill } from "react-bootstrap-icons";
import CommonGrid from "../../../../components/CommonGrid";
import { gridColumns_ScheduledOneTimePayments } from "../../../../Utils/TableColumnDefs";

const headers = {
  headers: {
    "Content-Type": "application/json",
    Authorization: "Basic UkVTVEFQSUxPQU5MSU5ROjg4V2VIZWxwVSQjQA==",
  },
};

const ScheduledPaymentsTable = () => {
  const data = useSelector(
    (state) => state.dashboard.borrowerScheduledOneTimePayments.data
  );
  const status = useSelector(
    (state) => state.dashboard.borrowerScheduledOneTimePayments.status
  );
  const dispatch = useDispatch();
  const { signal } = useAbortController();

  const userId = localStorage.getItem("apex_userid");

  useEffect(() => {
    if (status === loadingTypes.idle && userId) {
      dispatch(
        fetchBorrowerOneTimeScheduledPayments({
          userId,
          headers,
          signal,
        })
      );
    }
  }, [status, dispatch, userId]);

  useEffect(() => {
    dispatch(
      fetchBorrowerOneTimeScheduledPayments({
        userId,
        headers,
        signal,
      })
    );
  }, []);

  function handleDelete(achId) {
    dispatch(
      deleteScheduledOneTimePayment({
        achId,
        headers,
        refreshData: () =>
          dispatch(
            fetchBorrowerOneTimeScheduledPayments({
              userId,
              headers,
              signal,
            })
          ),
      })
    );
  }

  return (
    <div className="col-md-12 col-sm-12 border border-primary p-3 mb-5">
      <CommonGrid
        gridColumns={gridColumns_ScheduledOneTimePayments(handleDelete)}
        title="Scheduled One Time Payments"
        columnData={data}
        header={false}
        minHeight={"100%"}
        tHeight={""}
        tableTotal={["amount"]}
        showTotal={true}
        status={status}
      />
      {/* <h6>Scheduled One Time Payments</h6> */}
      {/* <div style={{ maxHeight: "50vh", overflow: "auto" }}>
        <table style={styles.container}>
          <thead>
            <tr>
              <th style={styles.th} className="bg-primary text-white">
                Loan Account
              </th>
              <th style={styles.th} className="bg-primary text-white">
                Amount
              </th>
              <th style={styles.th} className="bg-primary text-white">
                Date Issued
              </th>
              <th style={styles.th} className="bg-primary text-white">
                Action
              </th>
            </tr>
          </thead>
          <tbody>
            {status === loadingTypes.fulfilled ? (
              data?.length ? (
                data.map((el) => (
                  <tr key={el.cheque_number}>
                    <td
                      style={styles.td}
                      className="linkClick cursor-pointer text-decoration-underline"
                    >
                      {el.loan_account_number}
                    </td>
                    <td style={styles.td}>${el.amount.toFixed(2)}</td>
                    <td style={styles.td}>{el.date_issued}</td>
                    <td style={styles.td}>
                      {el.ach_id ? (
                        <DeleteButton onClick={() => handleDelete(el.ach_id)} />
                      ) : (
                        <DeleteButton disable={true} />
                      )}
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td style={styles.td} className="text-center" colSpan={4}>
                    No Scheduled Payments
                  </td>
                </tr>
              )
            ) : status === loadingTypes.loading ? (
              <div>
                <SpinnerBlock height="10vh" />{" "}
              </div>
            ) : null}
          </tbody>
        </table>
      </div> */}
    </div>
  );
};

export default ScheduledPaymentsTable;

const styles = {
  container: {
    width: "100%",
    borderCollapse: "collapse",
    marginTop: "20px",
  },
  th: {
    textAlign: "left",
    backgroundColor: "#f0f0f0",
    padding: "10px",
    border: "1px solid black",
  },
  td: {
    padding: "10px",
    border: "1px solid black",
  },
};
